var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.662,
    height: 20,
    viewBox: "0 0 16.662 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transportation",
    transform: "translate(-8 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 15.273,
    height: 1.35,
    transform: "translate(8.691 5.401)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M22.867,0H9.788A1.77,1.77,0,0,0,8,1.742V16.825a1.77,1.77,0,0,0,1.788,1.742h13.08a1.771,1.771,0,0,0,1.795-1.742V1.742A1.771,1.771,0,0,0,22.867,0Zm.406,16.825a.386.386,0,0,1-.119.278.409.409,0,0,1-.287.113H9.788a.4.4,0,0,1-.4-.392V1.742a.4.4,0,0,1,.4-.392h13.08a.409.409,0,0,1,.287.113.386.386,0,0,1,.119.278Z",
    transform: "translate(0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 5.554,
    height: 1.35,
    transform: "translate(13.551 2.701)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 15.273,
    height: 1.35,
    transform: "translate(8.691 12.153)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10277",
    "data-name": "Path 10277",
    d: "M26.476,45.35h-.128a.62.62,0,0,1-.628-.611v-.125a.6.6,0,0,1,.183-.434.637.637,0,0,1,.446-.18h.128a.638.638,0,0,1,.448.179.6.6,0,0,1,.184.435v.125a.6.6,0,0,1-.185.433.638.638,0,0,1-.447.178Zm-9.719,0h-.128A.62.62,0,0,1,16,44.739v-.125a.6.6,0,0,1,.183-.434.637.637,0,0,1,.446-.18h.128a.638.638,0,0,1,.448.179.6.6,0,0,1,.184.435v.125a.6.6,0,0,1-.185.433A.638.638,0,0,1,16.757,45.35Z",
    transform: "translate(-5.223 -29.147)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10278",
    "data-name": "Path 10278",
    d: "M0,.005,2.788,0l0,2.124L0,2.13Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 9.562, 17.681)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M0,0,2.784.005l0,2.124L0,2.124Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 23.424, 19.806)",
    fill: "#444"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.d409cc417e0be36cef66939f56bae04a.svg";
export { ForwardRef as ReactComponent };